import React from "react";
import { BetQLSportItem } from "src/common-services";

import { SharpPlay, UpgradeToView } from "../../RowComponents";
import { SubscriptionContext } from "../../../../services/SubscriptionService";

interface SharpCellOptions {
  game: any;
  index: number;
  filterKey: string;
  currentSportObj: BetQLSportItem;
  className?: string;
  fieldName?: string;
  showDraw?: boolean;
}

/**
 * Render the sharp % cell
 *
 * @param game The game to get the date from
 * @param index The index for the key
 * @param filterKey The bet type filter to user
 * @param currentSportObj The current spor that the user has selected
 */
export const getSharpCell = ({
  game,
  index,
  filterKey,
  currentSportObj,
  className,
  fieldName,
  showDraw,
}: SharpCellOptions) => {
  const periodFilter =
    filterKey === "spread" || filterKey === "moneyline" || filterKey === "total" ? `FG${filterKey}` : filterKey;
  let ticketCount = game[`sharp${periodFilter}CountHomeData`] + game[`sharp${periodFilter}CountAwayData`];
  if (showDraw) {
    ticketCount += game[`sharp${periodFilter}CountDrawData`];
  }
  const elClassName = className
    ? `${className} ${showDraw ? `${className}--draw` : ""}`
    : `games-table-column__pro-edge-cell ${showDraw ? "games-table-column__pro-edge-cell--draw" : ""}`;
  const isPositive = game[`sharp${periodFilter}Data`] >= 0;
  const isAway = game[`sharp${periodFilter}IsHome`] === false && isPositive;
  const isHome = game[`sharp${periodFilter}IsHome`] === true && isPositive;
  const isDraw = game[`sharp${periodFilter}IsHome`] === null && isPositive;
  return (
    <React.Fragment key={index}>
      <SubscriptionContext.Consumer>
        {({ hasSubscriptionAccess }) => {
          const hasAccess = hasSubscriptionAccess(currentSportObj.key);
          return game.freeGame || hasAccess ? (
            <div className={elClassName}>
              <div className="games-table-column__text-container">
                <SharpPlay
                  sharpPercent={isAway ? game[`sharp${periodFilter}Data`] : null}
                  ticketCount={ticketCount}
                  teamName={
                    currentSportObj.lookupKey.includes("ncaa") ? game.awayTeam.fullName : game.awayTeam.lastName
                  }
                  isBold={isAway}
                  sportObj={currentSportObj}
                />
              </div>
              {fieldName ? (
                <div className="games-table-column__text-container">
                  <p className="games-table-column__cell-title">{fieldName}</p>
                </div>
              ) : null}
              <div className="games-table-column__text-container">
                <SharpPlay
                  sharpPercent={isHome ? game[`sharp${periodFilter}Data`] : null}
                  ticketCount={ticketCount}
                  teamName={
                    currentSportObj.lookupKey.includes("ncaa") ? game.homeTeam.fullName : game.homeTeam.lastName
                  }
                  isBold={isHome}
                  sportObj={currentSportObj}
                />
              </div>
              {showDraw ? (
                <div className="games-table-column__text-container">
                  <SharpPlay
                    sharpPercent={isDraw ? game[`sharp${periodFilter}Data`] : null}
                    ticketCount={ticketCount}
                    teamName={
                      currentSportObj.lookupKey.includes("ncaa") ? game.homeTeam.fullName : game.homeTeam.lastName
                    }
                    isBold={isDraw}
                    sportObj={currentSportObj}
                  />
                </div>
              ) : null}
            </div>
          ) : (
            <UpgradeToView
              key={index}
              className={elClassName}
              fieldName={fieldName}
              isSharpStat={false}
              showText={true}
              trackingProps={{
                screen: "FeedView",
                page: "Games Table",
                source: "Pro Edge Cell",
                sport: currentSportObj.key,
                gameId: game.id,
                awayTeam: game.awayTeam.fullName,
                homeTeam: game.homeTeam.fullName,
              }}
            />
          );
        }}
      </SubscriptionContext.Consumer>
    </React.Fragment>
  );
};
